/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Alt_Pick_4_NeedInputs */

const en_pc_alt_pick_4_need = /** @type {(inputs: Pc_Alt_Pick_4_NeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You are on Linux`)
};

const zh_pc_alt_pick_4_need = /** @type {(inputs: Pc_Alt_Pick_4_NeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用 Linux`)
};

/**
* | output |
* | --- |
* | "You are on Linux" |
*
* @param {Pc_Alt_Pick_4_NeedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_alt_pick_4_need = /** @type {((inputs?: Pc_Alt_Pick_4_NeedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Alt_Pick_4_NeedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_alt_pick_4_need(inputs)
	return zh_pc_alt_pick_4_need(inputs)
});
export { pc_alt_pick_4_need as "pc.alt.pick.4.need" }